<template>
  <div class="cbg-white-container blog-listing-main">
    <div
      class="Head-div p-3 d-flex justify-content-between align-items-center border-bottom row my-0"
    >
      <h4 class="mb-0">Create News</h4>
      <div>
        <v-btn @click="goBack()" outlined text>
          <v-icon left>mdi-arrow-left-bold</v-icon>BACK
        </v-btn>
      </div>
    </div>
    <!-- <form class="form-group col-sm-12 mb-0" @submit.prevent="userRegister"> -->
    <CCol class="col-sm-12 p-0 row m-0">
      <CCol sm="6">
        <label for>Title</label>
        <input
          @keydown.space="preventEmptySpace"
          v-model="newsFormData.title"
          v-validate="'required'"
          name="title"
          type="text"
          placeholder="Title"
          class="form-control"
        />
        <span class="text-danger required-fields">{{ errors.first("title") }}</span>
      </CCol>

      <CCol sm="6">
        <label for>Upload Cover Image</label>
        <file-upload
          :media="'image'"
          :accept="accepted"
          label="upload"
          :src="docLink"
          :role="'patient'"
          :multiple="false"
          :module="'referred'"
          :drop="true"
          :isBlogImage="true"
          @uploaded="fileUploaded"
          :uploadFileToServer="uploadToServer"
          :uploadedImg="uploadedImg"
          @removeImage="deleteImg"
        ></file-upload>
        <span class="text-danger required-fields">{{ imageError }}</span>
      </CCol>

      <!-- <CCol sm="4">
        <label for class="col-sm-12 p-0 d-just-space"
          >Short Description <span>10 of 150</span></label
        >

        <textarea
          v-model="newsFormData.short_description"
          @keydown.space="preventEmptySpace"
          type="text"
          class="form-control"
          placeholder="Enter Short Description"
          rows="5"
          maxlength="150"
          v-validate="'required'"
          name="short_description"
        ></textarea>
        <span class="text-danger required-fields">
          {{ errors.first("short_description") }}
        </span>
      </CCol>-->

      <!-- <CCol sm="4">
        <label for>Tags</label>

        <v-combobox
          v-model="newsFormData.tags"
          @keydown.space="preventEmptySpace"
          hide-details
          multiple
          persistent-hint
          small-chips
          outlined
          v-validate="'required'"
          name="tags"
        >
          <template v-slot:no-data></template>
        </v-combobox>
        <span class="text-danger required-fields">{{ errors.first("tags") }}</span>
      </CCol>-->

      <CCol sm="6">
        <chip-combobox
          :tags="newsFormData.tags"
          :required="false"
          :requiredAlert="'Please select at least one tag'"
          @update:prop="value => newsFormData.tags = value"
        ></chip-combobox>
      <span class="text-danger required-fields">{{ errors.first("tags") }}</span>
      </CCol>

      <CCol sm="6">
        <label for>Select Category</label>
        <v-select
          :items="items"
          v-model="newsFormData.category"
          item-value="value"
          item-text="name"
          outlined
          hide-details
          placeholder="Select Category"
          v-validate="'required'"
          name="Category"
        ></v-select>
        <span class="text-danger required-fields">{{ errors.first("Category") }}</span>
      </CCol>

      <CCol sm="12">
        <h3>Content</h3>
        <editor
          :model-value="newsFormData.description"
          @update:modelValue="updateDescripiton"
          name="description"
        />
        <span v-if="descriptionError" class="text-danger required-fields">{{ descriptionError }}</span>
      </CCol>

      <CCol sm="12" md="12" class="flex-end">
        <v-btn
          v-if="Object.keys(this.$route.params).length !== 0"
          color="error"
          class="mr-4"
          @click="openSwalDelete($route.params.id)"
          :loading="showLoader"
        >Delete</v-btn>
        <v-btn v-else color="error" class="mr-4" @click="openSwalReset()">Discard</v-btn>
        <v-btn color="success" class="mr-4" @click="validateBeforeSubmit('publish')">Publish</v-btn>
        <v-btn color="success" outlined @click="validateBeforeDraft('draft')">Save as draft</v-btn>
      </CCol>
    </CCol>
    <loader v-if="showLoader"></loader>
    <!-- </form> -->
  </div>
</template>
<script>
import "@/assets/scss/_blogs.scss";
import chipCombobox from "@/components/chipCombobox.vue";
import FileUpload from "@/components/FileUpload.vue";
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
import Editor from "@/components/Editor/Editor";
import Swal from "sweetalert2";
import config from "@/config.js";
import { Validator } from "vee-validate";
const loader = () => import("@/components/loader.vue");
import goBack from "@/methods/utilities.vue";
export default {
  mixins: [goBack],
  $_veeValidate: {
    validator: "new"
  },
  components: {
    Datepicker,
    FileUpload,
    Editor,
    loader,
    chipCombobox
  },
  data() {
    return {
      accepted: "image/png,image/jpg,image/jpeg",
      docLink: null,
      showLoader: false,
      imageError: "",
      uploadedFileName: "",
      uploadedImgFullUrl: [],
      uploadedImg: [],
      uploadToServer: false,
      items: [
        { name: "India", value: "india" },
        { name: "International", value: "international" },
        { name: "Covid Update", value: "covid" },
        { name: "Court Rulings", value: "court" }
      ],
      newsFormData: {
        title: "",
        category: "",
        // short_description: "",
        description: "",
        tags: []
      },
      contentDescriptionValid: "",
      isValid: false,
      descriptionError: "",
      url: ""
    };
  },

  mounted() {
    if (Object.keys(this.$route.params).length !== 0) {
      const slugId =
        this.$route && this.$route.params && this.$route.params.slug;
      this.getNewsDetails(slugId);
    }
  },

  methods: {
    preventEmptySpace(e) {
      if (!e.target.value) e.preventDefault();
      else if (e.target.value[0] == " ")
        e.target.value = e.target.value.replace(/^\s*/, "");
    },

    getNewsDetails(slug) {
      this.showLoader = true;
      let url = `${config.BASE_URL}api/v2/admin/news/${slug}`;
      this.$http.get(url, {}).then(response => {
        if (response.body.status) {
          if (response.body.data) {
            this.showLoader = false;
            // this.newsFormData = { ...response.body.data };
            this.newsFormData.title = response.body.data.title;
            this.newsFormData.category = response.body.data.category;
            this.newsFormData.description = response.body.data.description;
            this.newsFormData.cover_photo = response.body.data.cover_photo;
            if (response.body.data.tags.length > 0) {
              this.newsFormData.tags = response.body.data.tags;
            }
            let imageName = this.newsFormData.cover_photo.split("/");
            if (imageName.length > 0) {
              this.uploadedImg = [imageName[3]];
              this.uploadedImgFullUrl[0] = this.newsFormData.cover_photo;
            }
          } else {
            this.newsFormData = {};
            this.showLoader = false;
          }
        }
      });
    },

    updateDescripiton(description) {
      this.newsFormData.description = description;
    },

    validateBeforeSubmit(status) {
      this.$validator.validateAll().then(valid => {
        this.validateImage(valid);
        this.validateDescription(this.contentDescriptionValid);
        if (valid && !this.imageError && !this.descriptionError) {
          // this.showLoader = true;
          this.isValid = true;
          this.updateAndCreateNews(status);
        } else {
          this.isValid = false;
        }
      });
    },
    validateBeforeDraft(status) {
      this.$validator.validate("title").then(titleValid => {
        this.$validator.validate("tags").then(tagsValid => {
          this.$validator.validate("Category").then(categoryValid => {
            this.validateImage(titleValid);
            this.validateDescription(this.contentDescriptionValid);
            if (
              titleValid ||
              tagsValid ||
              categoryValid ||
              !this.imageError ||
              !this.descriptionError
            ) {
              // this.showLoader = true;
              this.isValid = true;
              this.imageError = "";
              this.descriptionError = "";
              this.errors.clear();
              this.updateAndCreateNews(status);
            } else {
              this.isValid = false;
              this.imageError = "";
              this.descriptionError = "";
              this.errors.clear();
              this.openDraftSwal();
            }
          });
        });
      });
    },
    updateAndCreateNews(status) {
      if (status === "draft") {
        this.url = `${config.BASE_URL}api/v2/admin/news`;
        this.getApiCall(status);
      } else if (status === "publish") {
        this.url = `${config.BASE_URL}api/v2/admin/news`;
        this.openSwal(status);
      } else {
        console.log("not valid");
      }
    },

    getApiCall(status) {
      let obj = {
        title: this.newsFormData.title,
        cover_photo: this.uploadedImgFullUrl[0],
        // short_description: this.newsFormData.short_description,
        description: this.newsFormData.description,
        category: this.newsFormData.category,
        tags: this.newsFormData.tags,
        status: status
      };
      if (Object.keys(this.$route.params).length === 0) {
        this.createNews(status, obj);
      } else {
        this.updateNews(status, obj);
      }
    },

    createNews(status, obj) {
      this.$http.post(this.url, obj).then(response => {
        if (response.body.status) {
          this.showLoader = false;
          Swal.fire({
            title:
              status == "draft"
                ? `Draft Saved Successfully`
                : "News Published Successfully",
            icon: "success",
            showCancelButton: false,
            confirmButtonText: "Ok"
          }).then(result => {
            if (result.isConfirmed) {
              this.resetNewsForm();
              this.goTo("/newsListing");
            }
          });
        } else {
          this.showLoader = false;
        }
      });
    },

    updateNews(status, obj) {
      const userId = this.$route && this.$route.params && this.$route.params.id;
      let url = `${config.BASE_URL}api/v2/admin/news/${userId}`;
      this.$http.put(url, obj).then(response => {
        if (response.body.status) {
          this.showLoader = false;
          Swal.fire({
            title:
              status == "draft"
                ? `Draft Saved Successfully`
                : "News Published Successfully",
            icon: "success",
            showCancelButton: false,
            confirmButtonText: "Ok"
          }).then(result => {
            if (result.isConfirmed) {
              this.resetNewsForm();
              this.goTo("/newsListing");
            }
          });
        } else {
          this.showLoader = false;
        }
      });
    },

    openSwal(status) {
      Swal.fire({
        title: "Are you sure you want to Publish this news",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      }).then(result => {
        if (result.isConfirmed) {
          this.getApiCall(status, this.url);
        }
      });
    },

    openDraftSwal() {
      Swal.fire({
        title: "At least one field must be filled",
        icon: "warning",
        showCancelButton: false,
        confirmButtonText: "Ok"
      });
    },
    resetNewsForm() {
      this.newsFormData = {};
      this.uploadedImg = [];
      this.deleteImg();
    },

    validateImage(validForm) {
      if (this.uploadedImgFullUrl.length) {
        if (validForm) {
          this.uploadToServer = true;
        }
        this.imageError = "";
      } else {
        this.imageError = "This field is required";
      }
    },

    fileUploaded(files, uploaded, name) {
      this.uploadToServer = true;
      if (uploaded) {
        this.uploadToServer = false;
        this.uploadedFileName = name;
        this.uploadedImgFullUrl = files;
        this.uploadedImg = files.map(el => {
          return el.split("/").pop();
        });
        this.showLoader = false;
        this.imageError = "";
      } else {
        // this.loading = false;
        this.imageError = "";
      }
    },

    deleteImg() {
      this.uploadedImg = [];
      this.uploadedImgFullUrl = [];
    },

    openSwalDelete(id) {
      Swal.fire({
        title: "Are you sure you want to Delete this News",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      }).then(result => {
        if (result.isConfirmed) {
          this.deleteNews(id);
        }
      });
    },

    deleteNews(id) {
      let url = `${config.BASE_URL}api/v2/admin/news/${id}`;
      this.$http.delete(url, {}).then(response => {
        if (!!response.ok) {
          Swal.fire({
            title: "News Deleted Successfully",
            icon: "success",
            showCancelButton: false,
            confirmButtonText: "Ok"
          }).then(result => {
            if (result.isConfirmed) {
              this.goTo("/newsListing");
            }
          });
        }
      });
    },

    openSwalReset() {
      Swal.fire({
        title: "Are you sure you want to Discard this news",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      }).then(result => {
        if (result.isConfirmed) {
          // this.resetBlogForm();
          this.goTo("/newsListing");
        }
      });
    },

    goTo(url) {
      this.$router.push(url);
    },

    extractContent(s) {
      const span = document.createElement("span");
      span.innerHTML = s;
      return span.textContent || span.innerText;
    },

    validateDescription(value) {
      if (value) {
        if (/^\s*$/.test(value)) {
          this.descriptionError = "Cannot have only empty spaces";
        } else {
          this.descriptionError = "";
        }
      } else {
        this.descriptionError = "This field is required";
      }
    }
  },

  watch: {
    "newsFormData.description": function(newValue) {
      this.contentDescriptionValid = this.extractContent(newValue);
      this.validateDescription(this.contentDescriptionValid);
    }
  }
};
</script>
